export default __webpack_public_path__ + "static/media/calendar.7522c038.svg";